import { Flex, Icon, Link, Spacing, Switch, Text, useTheme } from '@billy/design-system'
import { ChangeEvent, ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

interface EInvoicingAutoForwardToggleProps {
  checked: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

export const EInvoicingAutoForwardToggle = ({ checked, onChange }: EInvoicingAutoForwardToggleProps): ReactElement => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Styled.EInvoicingAutoForwardToggleWrapper>
      <Flex alignItems="center" gap={Spacing.S8} justifyContent="space-between">
        <Flex gap={Spacing.S8}>
          <Icon color={theme.ds.colors.base.icon} size="lg" icon="refresh" />
          <Flex flexDirection="column">
            <Text weight="bold">{t('receipts.side_panel.e_invoices.auto_forward.title')}</Text>
            <Text variant="bodySM" colorVariant="secondary">
              {t('receipts.side_panel.e_invoices.auto_forward.description')}{' '}
              <Link
                href="https://help.shine.fr/shine-facture/fr/articles/16442546-le-partage-automatique-de-factures-electroniques"
                rel="noopener noreferrer"
                target="_blank"
              >
                {t('receipts.side_panel.e_invoices.auto_forward.learn_more')}
              </Link>
            </Text>
          </Flex>
        </Flex>
        <Switch checked={checked} onChange={onChange} />
      </Flex>
    </Styled.EInvoicingAutoForwardToggleWrapper>
  )
}
